import React, { Component } from "react";
import {
    Portlet,
    PortletBody,
    PortletHeader
} from "../../../partials/content/Portlet";
import { connect } from "react-redux";
import { Container, Row, Col, Card } from "react-bootstrap";
import { productivityServices } from "./Productivity.services";
import * as constants from "../../../constants";
import "./ProductivityTracker.css";
import { commonServices } from "../../../commonServices/commonServices";

class CityPerformanceTracker extends Component {
    constructor(props) {
        super(props);
        const today = new Date();
        this.state = {
            ...props,
            isFetching: false,
            scoreData: null,
            noDataMessage: null,
            selectedMonth: today.getMonth() + 1,
            selectedYear: today.getFullYear(),
            formattedCities: [],
            selectedCities: []
        };
    }

    async componentDidMount() {
        await this.getProductivityScore();
        this.getCities();
    }

    generateMonthYearOptions = () => {
        const options = [];
        const today = new Date();

        for (let i = 0; i < 12; i++) {
            const d = new Date(today.getFullYear(), today.getMonth() - i, 1);

            const month = d.getMonth() + 1;
            const year = d.getFullYear();

            const label = d.toLocaleString("default", {
                month: "long",
                year: "numeric"
            });

            options.push(
                <option key={`${month}-${year}`} value={`${month}-${year}`}>
                    {label}
                </option>
            );
        }

        return options;
    };


    handleMonthYearChange = async (e) => {
        const [month, year] = e.target.value.split("-");

        await this.setState({
            selectedMonth: Number(month),
            selectedYear: Number(year)
        });

        this.getProductivityScore();
    };

    getCities = async () => {
        const data = { pmsOperationStatus: "YES" };

        const result = await commonServices.getCities(data);
        if (result && result.status === 200) {
            const cities = result?.data?.cities || [];
            const allowedCityIds = this.state.userDetails?.cityId || [];

            const filteredCities = cities.filter(city =>
                allowedCityIds.includes(city.id)
            );

            const formattedCities = filteredCities.map(city => ({
                label: city.name,
                value: city.id
            }));
            this.setState({
                formattedCities
            });
        }
    };

    setSelected = (selectedCities) => {
        this.setState({ selectedCities }, () => {
            this.getProductivityScore();
        });
    };

    getProductivityScore = async () => {
        this.setState({ isFetching: true });
        const { selectedMonth, selectedYear } = this.state;

        const today = new Date();
        const isCurrentMonth =
            selectedMonth === today.getMonth() + 1 &&
            selectedYear === today.getFullYear();
        const params = {
            month: selectedMonth,
            year: selectedYear,
            // cityId: selectedCities.map(c => c.value)
            cityId: this.state.selectedCity ? Number(this.state.selectedCity) : 0
        };
        const result = await productivityServices.getCityScore(params);

        if (result && result.status === 200) {
            if (result.data && result.data.message) {
                this.setState({
                    scoreData: null,
                    noDataMessage: result.data.message
                });
            } else {
                this.setState({
                    scoreData: result.data,
                    noDataMessage: null
                });
            }
        }

        this.setState({ isFetching: false });
    };

    formatLabel = (key) => {
        return key
            .replace(/([A-Z])/g, " $1")
            .replace(/^./, (str) => str.toUpperCase());
    };

    renderScoreCard = (title, data, breakdown) => {
        if (!data) return null;

        const percentage = ((data.score / data.max) * 100).toFixed(0);

        return (
            <div className="metric-card">
                {/* Header */}
                <div className="metric-header">
                    <span className="metric-title">{title}</span>
                    <span className="metric-score">
                        {data.score.toFixed(2)}/{data.max}
                    </span>
                </div>

                {/* Progress */}
                <div className="progress">
                    <div
                        className="progress-bar"
                        style={{ width: `${percentage}%` }}
                    />
                </div>

                <div className="metric-percent">{percentage}% achieved</div>

                {/* Breakdown Section */}
                {breakdown && (
                    <div className="metric-breakdown">
                        {Object.keys(breakdown).map((key, index) => {
                            const item = breakdown[key];

                            // If structure is { score, max }
                            if (typeof item === "object" && item.score !== undefined) {
                                return (
                                    <div key={index} className="breakdown-row">
                                        <span>{this.formatLabel(key)}</span>
                                        <span>
                                            {item.score}/{item.max}
                                        </span>
                                    </div>
                                );
                            }

                            // If structure is just number (customer experience)
                            return (
                                <div key={index} className="breakdown-row">
                                    <span>{this.formatLabel(key)}</span>
                                    <span>{item}</span>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        );
    };

    getActiveBand = (score) => {
        if (score >= 80) return "band1";
        if (score >= 70) return "band2";
        if (score >= 61) return "band3";
        return "band4";
    };

    render() {
        const selectedCityName =
            this.state.formattedCities.find(
                city => city.value == this.state.selectedCity
            )?.label || "No City Selected";
        const { isFetching, scoreData, userDetails } = this.state;

        const activeBand =
            scoreData && this.getActiveBand(scoreData.totalScore);

        return (
            <Container fluid className="productivity-container">
                <Portlet fluidHeight>
                    <PortletHeader
                        title="Performance Scorecard"
                        toolbar={
                            <div className="leaderboard-toolbar">
                                <div className="toolbar-item">
                                    <select
                                        className="form-control productivity-month-select"
                                        value={this.state.selectedCity || ""}
                                        onChange={(e) =>
                                            this.setState(
                                                { selectedCity: e.target.value },
                                                () => this.getProductivityScore()
                                            )
                                        }
                                    >
                                        <option value="">All Cities</option>

                                        {this.state.formattedCities.map(city => (
                                            <option key={city.value} value={city.value}>
                                                {city.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>


                                <div className="toolbar-item">
                                    <select
                                        className="form-control productivity-month-select"
                                        value={`${this.state.selectedMonth}-${this.state.selectedYear}`}
                                        onChange={this.handleMonthYearChange}
                                    >
                                        {this.generateMonthYearOptions()}
                                    </select>
                                </div>

                            </div>
                        }
                    />
                    <PortletBody>
                        {isFetching && <p>{constants.LOADING_DATA}</p>}
                        {/* ✅ No Data Case */}
                        {!isFetching && this.state.noDataMessage && (
                            <div className="no-data-box">
                                <h5>{this.state.noDataMessage}</h5>
                                <p className="text-muted">
                                    Scorecard will be available once performance metrics are generated.
                                </p>
                            </div>
                        )}
                        {!isFetching && scoreData && (
                            <div className="productivity-wrapper">
                                <Row className="mb-4">
                                    <Col md={3}>
                                        <Card className="top-card">
                                            <Card.Body>
                                                <h4>
                                                    {selectedCityName}
                                                </h4>
                                                <p className="text-muted mb-0">{scoreData?.propertiesCount || 0} Properties </p>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="top-card">
                                            <Card.Body>
                                                <h3>{scoreData.totalScore}/100</h3>
                                                <p className="text-muted mb-0">Monthly Score</p>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="top-card">
                                            <Card.Body>
                                                <h5 className="text-warning">
                                                    {scoreData.payoutPercentage}% Payout
                                                </h5>
                                                <p className="text-muted mb-0">Payout Eligibility</p>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="top-card">
                                            <Card.Body>
                                                {scoreData.vsLastMonth ? (
                                                    <>
                                                        <h5
                                                            className={
                                                                scoreData.vsLastMonth >= 0
                                                                    ? "text-success"
                                                                    : "text-danger"
                                                            }
                                                        >
                                                            {scoreData.vsLastMonth >= 0 ? "▲" : "▼"}{" "}
                                                            {Math.abs(scoreData.vsLastMonth)} pts
                                                        </h5>
                                                        <p className="text-muted mb-0">Vs Last Month</p>
                                                    </>
                                                ) : (
                                                    <>
                                                        <h6 className="text-muted">Soon Available</h6>
                                                        <p className="text-muted mb-0">Vs Last Month</p>
                                                    </>
                                                )}
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>

                                <div className="payout-band mb-4">
                                    <div className={`band-item ${activeBand === "band1" ? "active" : ""}`}>
                                        <div className="band-range">81+</div>
                                        <div className="band-value">100%</div>
                                    </div>

                                    <div className={`band-item ${activeBand === "band2" ? "active" : ""}`}>
                                        <div className="band-range">71–80</div>
                                        <div className="band-value">75%</div>
                                    </div>

                                    <div className={`band-item ${activeBand === "band3" ? "active" : ""}`}>
                                        <div className="band-range">61–70</div>
                                        <div className="band-value">50%</div>
                                    </div>

                                    <div className={`band-item ${activeBand === "band4" ? "active" : ""}`}>
                                        <div className="band-range">&lt;60</div>
                                        <div className="band-value">Nil</div>
                                    </div>
                                </div>

                                <Row>
                                    <Col md={6}>
                                        {this.renderScoreCard(
                                            "Operations & Execution",
                                            scoreData.operationsExecution,
                                            scoreData.operationsExecution.breakdown
                                        )}
                                    </Col>

                                    <Col md={6}>
                                        {this.renderScoreCard(
                                            "Financial Discipline",
                                            scoreData.financialDiscipline
                                        )}
                                        {scoreData?.financialDiscipline?.financialPercentage < 100 && (
                                            <div className="card mt-3 shadow-sm">
                                                <div className="card-header bg-light">
                                                    <h5 className="mb-0 text-primary">How to Earn Full Score</h5>
                                                </div>
                                                <div className="card-body">
                                                    <p className="card-text">
                                                        Collect rent within 5 days of the due date to earn the maximum 15 points.
                                                    </p>
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered table-striped text-center mb-0">
                                                            <thead className="table-light">
                                                                <tr>
                                                                    <th scope="col">Delay</th>
                                                                    <th scope="col">Points</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>0–5 Days</td>
                                                                    <td className="text-success fw-bold">+15</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>6–10 Days</td>
                                                                    <td className="text-primary fw-bold">+10</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>11–15 Days</td>
                                                                    <td className="text-warning fw-bold">+5</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>&gt;15 Days / Not Received</td>
                                                                    <td className="text-danger fw-bold">0</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </Col>

                                    <Col md={6} className="mt-4">
                                        {this.renderScoreCard(
                                            "Customer Experience",
                                            scoreData.customerExperience,
                                            scoreData.customerExperience.breakdown
                                        )}
                                    </Col>

                                    <Col md={6} className="mt-4">
                                        {this.renderScoreCard(
                                            "Renewal Performance",
                                            scoreData.renewalPerformance,
                                            scoreData.renewalPerformance.breakdown
                                        )}
                                    </Col>
                                </Row>
                            </div>
                        )}
                    </PortletBody>
                </Portlet>
            </Container>
        );
    }
}

const mapStateToProps = (state) => ({
    userDetails: state.auth && state.auth.user
});

export default connect(
    mapStateToProps,
    null
)(CityPerformanceTracker);